export default {"src":"/_next/static/media/location.1a0c9f77.svg","height":23,"width":18,"blurWidth":0,"blurHeight":0};